import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { DutchAddress } from './address.model';

/**
 * @ngdoc service
 * @name ApAddressResource
 * @module ApGenericModule
 *
 * @description
 * Service providing address functionality
 **/
@Injectable({ providedIn: 'root' })
export class ApAddressResource {
    private readonly http = inject(HttpClient);

    private readonly baseUrl: string = '/services/apix-pega-clm/api/address';
    private _apiKey: string = '{<APIC-ADDRESS-API-KEY>}';

    get apiKey() {
        return this._apiKey;
    }

    set apiKey(apiKey: string) {
        this._apiKey = apiKey;
    }

    getAddress(zipcode: string, houseNr: string): Observable<DutchAddress> {
        let params = new HttpParams();
        params = params.set('zipcode', zipcode);
        params = params.set('housenumber', houseNr);
        params = params.set('X-Bank', 'sns');

        return this.http.get<DutchAddress>(this.baseUrl, {
            headers: this.getHeaders(),
            params
        });
    }

    private getHeaders(): HttpHeaders {
        return new HttpHeaders().set('X-Api-Key', this.apiKey);
    }
}
